import { render, staticRenderFns } from "./DetailJournal.vue?vue&type=template&id=526807d5&scoped=true"
import script from "./DetailJournal.vue?vue&type=script&lang=js"
export * from "./DetailJournal.vue?vue&type=script&lang=js"
import style0 from "./DetailJournal.vue?vue&type=style&index=0&id=526807d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526807d5",
  null
  
)

export default component.exports